module.exports = {
  body: {
    backgroundColor:'bg-black',
    textColor: 'text-white',
    backgroundColorPrimary:'bg-black',

    selectedBackgroundColor:'bg-white',
    selectedTextColor:'text-black',

    defaultBackgroundImage: false,
    defaultBackgroundImageColor: 'eaeaea',

    backgroundColorDEFAULT: '#000',
    primaryLoaderColor: 'white',
    primaryColor: 'text-white',
    selectedItem: 'primary',
    TypeDisplayColor: 'primary',
    startButtonTextColor:'text-white',
    startButtonBackgroundColor:'bg-black',
    defaultTextColorButton:'text-white'
  },
  card: {
    backgroundColorHavingSubItem: 'bg-gray-100',
    backgroundColor: 'bg-gray-200',
    title: 'text-gray-1000',
    iconWrapper: 'bg-gray-300'
  },
  addToCart: {
    textColorPlus:'text-black',
    backgroundColor: 'bg-gray-700',
    backgroundColorPlus: 'bg-white',
    backgroundColorMinus: 'bg-white',
    textColor:'bg-white',
    border: '',
    title: 'text-primary',
    notSelectedBackgroundColor: 'bg-gray-300',
    selectedBackgroundColor: 'bg-primary',
    addToCartButtonBackgroundColor: 'bg-white',
    addToCartButtonTextColor: 'text-black',
    deleteButtonTextColor: 'text-red-600'
  },
  footer: {
    button: 'outline-none w-half hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center bg-gray-600'
  },
  header: {
    backgroundColor: 'bg-gray-900',
    selectedItemColor: 'white'
  },
  middleScreen: {
    backgroundColor: ''
  },
  processBar: {
    itemDoneTextColor: 'text-white',
    itemDoneBackgroundColor: 'bg-black',
    currentItemTextColor:'text-gray-600',
    currentItemBackgroundColor:'bg-gray-600',
    futureItemBackgroundColor: 'bg-white',
    futureItemTextColor: 'text-black',
    futureItemBottomTextColor:'text-white'
  },
  floatingCartInfoButton: {
    unabledButtonBrackgroundColor: 'bg-gray-500',
  },
  paymentMethod:
  {
    textColor: 'text-black',
    arrowTextolor: 'text-white'
  },
  AdditionsPopUp:
  {
    HeadertextColor: 'text-white',
    HeaderTextBackgroundColor: 'bg-white'
  },
  Cart:
  {
    backgroundColor: 'bg-gray-900',
  }
}